(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92093],{

/***/ 49617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/constants/linkType.js
var linkType = __webpack_require__(45177);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/components/CallToAction/styles.module.scss
var styles_module = __webpack_require__(73331);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/CallToAction/utils/useProps.js









/* harmony default export */ function useProps(props) {
    var scrollTop = function scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var page = props.page, view = props.view, titleProp = props.title, data = props.data, buttonTitleProp = props.buttonTitle, className = props.className, slugProp = props.slug, rest = (0,_object_without_properties/* default */.Z)(props, [
        "page",
        "view",
        "title",
        "data",
        "buttonTitle",
        "className",
        "slug"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "title",
        "subtitle",
        "new",
        "imagesBundle",
        "buttonTitle",
        "type",
        "files",
        "isOpenFeedbackForm",
        "url", 
    ]), isNew = ref.new, title = ref.title, subtitle = ref.subtitle, imagesBundle = ref.imagesBundle, buttonTitle = ref.buttonTitle, rawFiles = ref.files, type = ref.type, isOpenFeedbackForm = ref.isOpenFeedbackForm, ctaUrl = ref.url;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,router.useRouter)(), slug = ref2.query.slug;
    var images = (imagesBundle || []).map(helper/* getImage */.gJ);
    var titles = (title || titleProp).split("||");
    var files = (rawFiles || []).map(helper/* getFileUrl */.qm);
    var _obj;
    var classNames = classnames_default()((styles_module_default()).container, (styles_module_default())[type], (styles_module_default())[view], (styles_module_default())[page], className, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).openContact, isOpenFeedbackForm), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).scrollBlock, type === linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).showScrollBlock, type === linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock && show), _obj));
    return (0,_object_spread/* default */.Z)({
        titles: titles,
        subtitle: subtitle,
        images: images,
        isNew: isNew,
        buttonTitle: buttonTitleProp || buttonTitle,
        type: type,
        downloadLink: files[0],
        isOpenFeedbackForm: isOpenFeedbackForm,
        slug: slugProp || slug,
        ctaUrl: ctaUrl,
        show: show,
        classNames: classNames,
        setShow: setShow,
        scrollTop: scrollTop
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/CallToAction/index.jsx








var Contact = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 82407).then(__webpack_require__.bind(__webpack_require__, 82407));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82407)
            ];
        }
    }
});
var GetBook = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(62736), __webpack_require__.e(28532)]).then(__webpack_require__.bind(__webpack_require__, 51985));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51985)
            ];
        }
    }
});
var Subscribe = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(62736), __webpack_require__.e(39133)]).then(__webpack_require__.bind(__webpack_require__, 51246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51246)
            ];
        }
    }
});
var ScrollBlock = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(62736), __webpack_require__.e(43335)]).then(__webpack_require__.bind(__webpack_require__, 110));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(110)
            ];
        }
    }
});
var CallToAction = function(props) {
    var ref = useProps(props), titles = ref.titles, subtitle = ref.subtitle, buttonTitle = ref.buttonTitle, type = ref.type, images = ref.images, downloadLink = ref.downloadLink, handleOnClick = ref.handleOnClick, slug = ref.slug, ctaUrl = ref.ctaUrl, sectionRef = ref.sectionRef, show = ref.show, setShow = ref.setShow, classNames = ref.classNames, scrollTop = ref.scrollTop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            images.map(function(param, i) {
                var url = param.url, alt = param.alt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: url,
                    alt: alt,
                    className: classnames_default()((styles_module_default()).image, (styles_module_default())["image-".concat(i)])
                });
            }),
            function() {
                switch(type){
                    case linkType/* LINK_TYPE.subscribe */.x.subscribe:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscribe, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            slug: slug
                        });
                    case linkType/* LINK_TYPE.book */.x.book:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GetBook, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            bookCover: images[0],
                            downloadLink: downloadLink,
                            slug: slug
                        });
                    case linkType/* LINK_TYPE.callToAction */.x.callToAction:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: handleOnClick,
                            url: ctaUrl
                        });
                    case linkType/* LINK_TYPE.scrollBlock */.x.scrollBlock:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollBlock, {
                            sectionRef: sectionRef,
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            bookCover: images[0],
                            downloadLink: downloadLink,
                            slug: slug,
                            show: show,
                            setShow: setShow
                        });
                    case linkType/* LINK_TYPE.scrollTop */.x.scrollTop:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: scrollTop,
                            url: ctaUrl
                        });
                    default:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                            titles: titles,
                            subtitle: subtitle,
                            buttonTitle: buttonTitle,
                            handleOnClick: handleOnClick,
                            url: ctaUrl
                        });
                }
            }()
        ]
    });
};
CallToAction.defaultProps = {
    href: "",
    className: null,
    title: "",
    subtitle: "",
    data: {}
};
CallToAction.propTypes = {
    data: prop_types_default().instanceOf(Object),
    title: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    buttonTitle: (prop_types_default()).string,
    href: (prop_types_default()).string,
    type: (prop_types_default()).string,
    handleOnClick: (prop_types_default()).func,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_CallToAction = (CallToAction);


/***/ }),

/***/ 45177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LINK_TYPE; }
/* harmony export */ });
var LINK_TYPE = {
    bookmark: "bookmark",
    callToAction: "call-to-action",
    button: "button",
    youTube: "youtube-video",
    book: "book",
    subscribe: "subscribe",
    scrollBlock: "scroll-block",
    scrollTop: "scroll-top"
};


/***/ }),

/***/ 73331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"web-app-development-company":"styles_web-app-development-company__1HB5w","h3":"styles_h3__IRjjx","container":"styles_container__pO5_j","content":"styles_content__xSHAX","title":"styles_title__KGr5K","image":"styles_image__G8OXV","subtitle":"styles_subtitle__CZxyq","button":"styles_button__Zx8JO","openContact":"styles_openContact__P9cjT","book":"styles_book__gorl4","subscribe":"styles_subscribe__OZAA7","isSubscribed":"styles_isSubscribed__ywNq6","page":"styles_page___1I_h","p":"styles_p__91NqR","scrollBlock":"styles_scrollBlock__YSLoG","showScrollBlock":"styles_showScrollBlock__5hZIR"};

/***/ })

}]);